import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Resources } from 'app/models2/maintenance/resources';
import { InputOrOutputInventory } from 'app/models2/inventory/input-or-output-inventory';
import { Item } from 'app/models2/inventory/item';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { MenuBreadCrumb, MessageService, SessionService, TableColumns, TableConfiguration, params } from 'brainloper-ui';
import { Data } from 'app/models2/commos/base-response-data';
import { UtilsServiceService } from 'app/services/utils-service.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  public urlGetTablaMinStock: string = `${EndpointDictionary.Inventory.INVENTORY_TABLE_STOCK_MIN}`

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Notificaciones",
    },
    {
      name: "Alerta",
      current: true
    }
  ]

  public resources: Array<Resources> = [{ itemName: '' }]

  public view: boolean = true
  public reloadMinStock = new EventEmitter<any>()
  public paramsMinStock: params[] = [{ id: 'warehouseId', value: '0' }]
  public configurationMinStock: TableConfiguration = {    
    primaryKey: 'itemInventoryId',
  };

  public columnsMinStock: TableColumns<Item>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'itemName',
      label: 'Item',
      type: 'text',
      style: {
        textAlign: 'center',

      },
    },
    {
      ID: 'amount',
      label: 'Cantidad Actual',
      type: 'number',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'minStock',
      label: 'Stock Mínimo',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'consecutive',
      label: '# Orden Compra',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'providerName',
      label: 'Proveedor',
      type: 'string',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    }
  ];


  constructor(
    private message: MessageService,
    private session: SessionService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private utils : UtilsServiceService
  ) { }

  async ngOnInit(){
    this.activeRoute.queryParamMap
      .subscribe(async (params) => {
        const warehouseId = params.get('warehouseId');
        this.paramsMinStock[0].value = parseInt(warehouseId)
      })
  }

  async dataResources($event: Data<Array<InputOrOutputInventory>>) {
    this.resources = $event.data
  }

  async responseInput($event) {
    this.processItems($event, "minStockData", "almacen/entradas_inventario/detalle", "Entrada de Inventario Stock Minimo");
  }

  async responsePurchaseOrder($event) {
    this.processItems($event, "purchaseOrderData", "almacen/orden_compra/detalle", "Notificación Orden de Comrpa");
  }

  async processItems($event: Resources[], dataKey: string, route:string, message: string){
    for (const  [i, item] of $event.entries()) {
      item.currentAmount = item.amount
      item.amount = item.minStock - item.amount + 1;
      $event[i].itemInventoryId = item.itemId
    }
    this.session.setData(dataKey, $event)
    let url = this.utils.getQueryParams(`${route}${$event[0].warehouseId?'?warehouseId='+$event[0].warehouseId:''}`);
    this.router.navigate([`${url.url}`], {
      queryParams: url.params,
    }); 
    this.message.SuccessToast(message)
  }
}
